import { render, staticRenderFns } from "./_Coordonnees.vue?vue&type=template&id=50f9e768&"
import script from "./_Coordonnees.vue?vue&type=script&lang=ts&"
export * from "./_Coordonnees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports